const topWork = (() => {

  if (document.querySelector("body#pageTop") !== null) {



    let sW = window.innerWidth;

    let secWork = document.querySelector('#jsSecWork');
    let workWraps = secWork.querySelectorAll('.js-work-wrap');

    let num = 0;

    if (sW > 768) {
      num = 3;
    } else {
      num = 2;
    }

    workWraps.forEach((element, index) => {

      const elems = element.querySelectorAll('.work-area');
      const elemsArray = Array.from(elems)
      // const num = 3; // 分割単位
      // console.log(elemsArray)
      const chunkedArr = ((arr, size) => arr.flatMap((_, i, a) => i % size ? [] : [a.slice(i, i + size)]))(elemsArray, num);
      // console.log(chunkedArr.length);
      // console.log(chunkedArr[0]);

      chunkedArr.forEach((element2, index2) => {

        let to = gsap.set(element2, {
          opacity: 0,
          transform: 'translateY(2rem)',
        })

        to = gsap.to(element2, {
          opacity: 1,
          transform: 'translateY(0rem)',
          duration: 0.5,
          ease: "power1.inOut",
          scrollTrigger: {
            toggleActions: 'play none none reverse',
            invalidateOnRefresh: true,
            trigger: element2[0],
            start: "0% 80%",
            end: "100% 20%",
            // markers: true
          },
          stagger: {
            each: 0.1,
          },
        })


        let target = document.querySelector('body');
        let observer = new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            to.scrollTrigger.refresh()
          });
        });
        observer.observe(target);

      });

    });



  }
})()
export default topWork;